import { SupportTicketMap } from './support.action';

const initState = {
    ticketList: {
        data: [],
        recordsTotal: 0
    },
    isLoading: false,
    refreshList: true,
    selectedTicket: {},
    openTicketDetailsModal: false,
    skip: 0,
    limit: 10,
}

export const reducer = (state = initState, action) => {
    switch (action.type) {
        case SupportTicketMap.ADD_TICKET_COMMENT_START:
        case SupportTicketMap.GET_TICKET_DETAILS_START:
        case SupportTicketMap.GET_ALL_USER_TICKETS_START:
        case SupportTicketMap.CREATE_TICKET_START: {
            return {
                ...state,
                isLoading: true
            }
        }
        case SupportTicketMap.CREATE_TICKET_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                refreshList: true
            }
        }
        case SupportTicketMap.GET_ALL_USER_TICKETS_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                refreshList: false,
                ticketList: action.payload
            }
        }
        case SupportTicketMap.GET_TICKET_DETAILS_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                openTicketDetailsModal: true,
                selectedTicket: action.payload
            }
        }
        case SupportTicketMap.ADD_TICKET_COMMENT_SUCCESS: {
            return {
                ...state,
            }
        }
        case SupportTicketMap.TOGGLE_TICKET_DETAILS_MODAL: {
            return {
                ...state,
                openTicketDetailsModal: action.payload,
                selectedTicket: !action.payload ? {} : state.selectedTicket,
            }
        }
        case SupportTicketMap.ADD_TICKET_COMMENT_ERROR: 
        case SupportTicketMap.GET_TICKET_DETAILS_ERROR: 
        case SupportTicketMap.GET_ALL_USER_TICKETS_ERROR:
        case SupportTicketMap.CREATE_TICKET_ERROR: {
            return {
                ...state,
                isLoading: false,
                refreshList: false,
            }
        }

        case SupportTicketMap.SET_TICKET_BATCH_NUMBER: {
            return {
                ...state,
                skip: action.payload,
                refreshList: true,
            }
        }

        default:
            return {
                ...state
            }
    }
}